export default __webpack_public_path__ + "static/media/bookshelf.9ca98d5e.png";